<div class="info-page">
  <h3>Análise Monitoramento - {{ actionLabel }} </h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Status Atual<sup class="text-danger ms-2">*</sup></label>
      <ng-select id="analysis_stat_id" class="ng-select-alternative" (change)="onStatusChange()" [items]="statusList" bindLabel="label" bindValue="id" placeholder="Selecione o Status Atual" formControlName="analysis_stat_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('analysis_stat_id')" [erros]="fieldErros('analysis_stat_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="showSituacao">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Situação</label>
      <ng-select id="analysis_sub_stat_id" class="ng-select-alternative" (change)="onStatusChange()" [items]="situacaoList" bindLabel="label" bindValue="id" placeholder="Selecione a Situação" formControlName="analysis_sub_stat_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('analysis_sub_stat_id')" [erros]="fieldErros('analysis_sub_stat_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição<sup class="text-danger ms-2">*</sup></label>
      <textarea id="description" class="form-control" rows="6" formControlName="description" required maxlength="1000"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end m-b">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>

<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>